import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Countdown, Button, TrustBar } from './Shared';
const SAVINGS = [['Merienda envasada comprada', '$60 a $120 UYU'], ['Compra de apuro en el camino', '$80 a $150 UYU'], ['Merienda planificada con el kit', '$15 a $35 UYU'], ['Ahorro diario estimado', '$45 a $85 UYU'], ['Ahorro mensual estimado', '$1.300 a $1.900 UYU'], ['Ahorro anual estimado', '$13.000 a $19.000 UYU']];
export function Precios() {
  return <>
      <section className="border-y border-orange-100 bg-orange-50 px-4 py-14 text-center" data-id="element-143">
        <div className="mx-auto max-w-3xl" data-id="element-144">
          <span className="inline-flex items-center gap-2 rounded-full bg-red-100 px-4 py-1.5 text-sm font-bold text-red-700" data-id="element-145">
            <span className="h-2 w-2 animate-pulse rounded-full bg-red-600" data-id="element-146" />{' '}
            Precio de lanzamiento · termina pronto
          </span>
          <h2 className="mt-5 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-147">
            ⏰ PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>
          <div className="mt-3" data-id="element-148">
            <Countdown data-id="element-149" />
          </div>
          <p className="mt-4 text-lg font-medium text-brand-text" data-id="element-150">
            Después vuelve a su precio real de $590 UYU. No vuelve esta oferta.
          </p>
        </div>
      </section>

      <section className="bg-brand-base px-4 py-20" data-id="element-151">
        <div className="mx-auto max-w-5xl" data-id="element-152">
          <header className="text-center" data-id="element-153">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-154">
              La matemática del ahorro
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-4xl" data-id="element-155">
              Lo que cuesta improvisar vs. planificar
            </h2>
          </header>
          <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-2xl border border-brand-sky bg-white shadow-sm" data-id="element-156">
            <div className="grid grid-cols-[1fr_auto] bg-brand-deep px-5 py-3 text-sm font-bold text-white" data-id="element-157">
              <span data-id="element-158">Situación</span>
              <span data-id="element-159">Costo estimado</span>
            </div>
            {SAVINGS.map(([label, value], index) => <div key={label} className={`grid grid-cols-[1fr_auto] gap-4 px-5 py-4 text-sm font-medium md:text-base ${index % 2 === 0 ? 'bg-white' : 'bg-brand-lightBlue'} ${index >= 3 ? 'text-brand-green' : 'text-brand-text'}`} data-id="element-160">
                <span data-id="element-161">{label}</span>
                <strong data-id="element-162">{value}</strong>
              </div>)}
          </div>
          <article className="mx-auto mt-10 max-w-3xl rounded-3xl border border-brand-sky bg-white p-7 text-center shadow-sm" data-id="element-163">
            <p className="text-sm font-bold uppercase tracking-wider text-brand-gray" data-id="element-164">
              Inversión en el kit completo
            </p>
            <p className="mt-2 font-display text-5xl font-bold text-brand-orange" data-id="element-165">
              $390 <span className="text-xl" data-id="element-166">UYU</span>
            </p>
            <div className="my-7 border-t border-slate-100" data-id="element-167" />
            <p className="font-display text-xl font-bold text-brand-deep" data-id="element-168">
              Con una semana de meriendas planificadas:
            </p>
            <p className="mt-3 text-lg text-brand-text" data-id="element-169">
              5 días × $80 UYU de ahorro = <strong data-id="element-170">$400 UYU</strong>
            </p>
            <p className="mt-6 flex items-center justify-center gap-2 font-bold text-brand-green" data-id="element-171">
              <CheckCircle2Icon className="h-6 w-6" data-id="element-172" /> Recuperaste la inversión
              en la primera semana.
            </p>
            <p className="mt-2 font-medium text-brand-text" data-id="element-173">
              A partir de la segunda semana, todo es ahorro puro. De por vida.
            </p>
          </article>
        </div>
      </section>

      <section id="precios" className="scroll-mt-10 bg-white px-4 py-20" data-id="element-174">
        <div className="mx-auto max-w-xl" data-id="element-175">
          <header className="text-center" data-id="element-176">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-brand-orange" data-id="element-177">
              Elegí Meriendas que Acompañan
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-deep md:text-5xl" data-id="element-178">
              Un kit para{' '}
              <span className="text-brand-orange" data-id="element-179">todas las mañanas.</span>
            </h2>
            <p className="mt-4 text-lg font-medium leading-relaxed text-brand-text" data-id="element-180">
              Incluye los 6 tomos completos · 3 bonos estratégicos · 60 ideas
              listas y el planificador de 4 semanas.
            </p>
          </header>
          <article className="relative mt-12 overflow-hidden rounded-3xl border-2 border-brand-orange bg-orange-50 p-6 shadow-[0_12px_30px_rgba(245,124,0,0.18)] md:p-8" data-id="element-181">
            <span className="absolute right-5 top-0 rounded-b-xl bg-brand-orange px-4 py-1.5 text-xs font-bold text-white" data-id="element-182">
              LA OPCIÓN MÁS INTELIGENTE
            </span>
            <div className="pt-6" data-id="element-183">
              <div className="flex items-start gap-4" data-id="element-184">
                <span className="text-4xl" data-id="element-185">🍎</span>
                <div data-id="element-186">
                  <h3 className="font-display text-2xl font-bold text-brand-deep" data-id="element-187">
                    KIT COMPLETO
                  </h3>
                  <p className="mt-1 font-medium text-brand-text" data-id="element-188">
                    6 tomos + 3 bonos + 60 meriendas + planificador de 4 semanas
                  </p>
                </div>
              </div>
              <span className="mt-5 inline-block rounded-full border border-green-200 bg-brand-greenSoft px-3 py-1 text-xs font-bold text-brand-green" data-id="element-189">
                🟢 AHORRÁS $480 UYU
              </span>
              <div className="mt-6 flex items-end gap-3" data-id="element-190">
                <span className="pb-1 text-lg font-semibold text-brand-gray line-through" data-id="element-191">
                  $870 UYU
                </span>
                <span className="font-display text-5xl font-bold text-brand-deep" data-id="element-192">
                  $390
                </span>
                <span className="pb-2 text-sm font-bold text-brand-gray" data-id="element-193">
                  UYU
                </span>
              </div>
            </div>
            <div className="mt-7" data-id="element-194">
              <Button className="py-5" data-id="element-195">🌟 LO QUIERO AHORA — $390 UYU</Button>
            </div>
            <div className="mt-6" data-id="element-196">
              <TrustBar data-id="element-197" />
            </div>
          </article>
          <p className="mt-5 text-center text-sm font-semibold text-brand-orange" data-id="element-198">
            ⚡ El precio actual es exclusivo para los primeros 500 compradores.
          </p>
          <div className="mt-16 rounded-3xl border border-brand-sky bg-brand-lightBlue p-7 shadow-sm" data-id="element-199">
            <h3 className="text-center font-display text-2xl font-bold text-brand-deep" data-id="element-200">
              Por qué el kit completo es la decisión más inteligente
            </h3>
            <div className="mt-7 grid gap-5 md:grid-cols-2" data-id="element-201">
              <div className="rounded-xl border border-slate-200 bg-white p-5" data-id="element-202">
                <p className="font-bold text-brand-deep" data-id="element-203">
                  SI COMPRÁS SOLO UN TOMO ·
                </p>
                <p className="mt-2 text-sm leading-relaxed text-brand-text" data-id="element-204">
                  Tenés una parte del sistema. Resolvés una situación puntual.
                  Pero el lunes siguiente la pregunta puede volver.
                </p>
              </div>
              <div className="rounded-xl border border-brand-sky bg-white p-5" data-id="element-205">
                <p className="font-bold text-brand-blue" data-id="element-206">
                  SI COMPRÁS EL KIT COMPLETO POR $390 UYU ·
                </p>
                <p className="mt-2 text-sm leading-relaxed text-brand-text" data-id="element-207">
                  Tenés todo integrado para resolver cualquier mañana, recuperás
                  la inversión en la primera semana y a partir de la segunda
                  todo es ahorro puro.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}